// extracted by mini-css-extract-plugin
export default {"trendingImg":"trending_trendingImg__MTimF","trendingCard":"trending_trendingCard__8Mgo1"};